<div class="scroll-to-top" [@stateChanged]="state" (click)="scrollToTop()">
  <i class="icon-arrow-up-circle" aria-hidden="true"></i>
</div>
